/**
 * Created by valentin on 20/07/2017.
 */
import {CANVAS_HEIGHT, CANVAS_WIDTH} from './TeethViewer'
import {ToothPosition} from './ToothPosition'

const milkAndPermanentTeethPositions = {
  top: {
    right: [
      new ToothPosition(21, CANVAS_WIDTH * 0.465, CANVAS_HEIGHT * 0.000),
      new ToothPosition(22, CANVAS_WIDTH * 0.580, CANVAS_HEIGHT * 0.015),
      new ToothPosition(26, CANVAS_WIDTH * 0.785, CANVAS_HEIGHT * 0.220),
      new ToothPosition(61, CANVAS_WIDTH * 0.460, CANVAS_HEIGHT * 0.090),
      new ToothPosition(62, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.130),
      new ToothPosition(63, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.180),
      new ToothPosition(64, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.245),
      new ToothPosition(65, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.330)
    ],
    left: [
      new ToothPosition(11, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.000),
      new ToothPosition(12, CANVAS_WIDTH * 0.225, CANVAS_HEIGHT * 0.015),
      new ToothPosition(16, CANVAS_WIDTH * 0.020, CANVAS_HEIGHT * 0.220),
      new ToothPosition(51, CANVAS_WIDTH * 0.330, CANVAS_HEIGHT * 0.090),
      new ToothPosition(52, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.130),
      new ToothPosition(53, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.180),
      new ToothPosition(54, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.245),
      new ToothPosition(55, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.330)
    ]
  },
  bottom: {
    right: [
      new ToothPosition(46, CANVAS_WIDTH * 0.785, CANVAS_HEIGHT * 0.665),
      new ToothPosition(71, CANVAS_WIDTH * 0.470, CANVAS_HEIGHT * 0.790),
      new ToothPosition(72, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.755),
      new ToothPosition(73, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.705),
      new ToothPosition(74, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.640),
      new ToothPosition(75, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.560)
    ],
    left: [
      new ToothPosition(36, CANVAS_WIDTH * 0.020, CANVAS_HEIGHT * 0.665),
      new ToothPosition(81, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.790),
      new ToothPosition(82, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.755),
      new ToothPosition(83, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.705),
      new ToothPosition(84, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.640),
      new ToothPosition(85, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.560)
    ]
  }
}

const test = {
  top: {
    right: [
      new ToothPosition(61, CANVAS_WIDTH * 0.460, CANVAS_HEIGHT * 0.090),
      new ToothPosition(62, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.130),
      new ToothPosition(63, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.180),
      new ToothPosition(64, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.245),
      new ToothPosition(65, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.330)
    ],
    left: [
      new ToothPosition(51, CANVAS_WIDTH * 0.330, CANVAS_HEIGHT * 0.090),
      new ToothPosition(52, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.130),
      new ToothPosition(53, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.180),
      new ToothPosition(54, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.245),
      new ToothPosition(55, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.330)
    ]
  },
  bottom: {
    right: [
      new ToothPosition(71, CANVAS_WIDTH * 0.470, CANVAS_HEIGHT * 0.790),
      new ToothPosition(72, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.755),
      new ToothPosition(73, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.705),
      new ToothPosition(74, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.640),
      new ToothPosition(75, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.560)
    ],
    left: [
      new ToothPosition(81, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.790),
      new ToothPosition(82, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.755),
      new ToothPosition(83, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.705),
      new ToothPosition(84, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.640),
      new ToothPosition(85, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.560)
    ]
  }
}

const permanentTeethPositions = {
  top: {
    right: [
      new ToothPosition(21, CANVAS_WIDTH * 0.465, CANVAS_HEIGHT * 0.000),
      new ToothPosition(22, CANVAS_WIDTH * 0.580, CANVAS_HEIGHT * 0.015),
      new ToothPosition(23, CANVAS_WIDTH * 0.665, CANVAS_HEIGHT * 0.050),
      new ToothPosition(24, CANVAS_WIDTH * 0.730, CANVAS_HEIGHT * 0.100),
      new ToothPosition(25, CANVAS_WIDTH * 0.765, CANVAS_HEIGHT * 0.155),
      new ToothPosition(26, CANVAS_WIDTH * 0.785, CANVAS_HEIGHT * 0.220),
      new ToothPosition(27, CANVAS_WIDTH * 0.795, CANVAS_HEIGHT * 0.295),
      new ToothPosition(28, CANVAS_WIDTH * 0.800, CANVAS_HEIGHT * 0.375),
      new ToothPosition(61, CANVAS_WIDTH * 0.460, CANVAS_HEIGHT * 0.090),
      new ToothPosition(62, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.130),
      new ToothPosition(63, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.180),
      new ToothPosition(64, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.245),
      new ToothPosition(65, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.330)
    ],
    left: [
      new ToothPosition(11, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.000),
      new ToothPosition(12, CANVAS_WIDTH * 0.225, CANVAS_HEIGHT * 0.015),
      new ToothPosition(13, CANVAS_WIDTH * 0.125, CANVAS_HEIGHT * 0.050),
      new ToothPosition(14, CANVAS_WIDTH * 0.075, CANVAS_HEIGHT * 0.100),
      new ToothPosition(15, CANVAS_WIDTH * 0.045, CANVAS_HEIGHT * 0.155),
      new ToothPosition(16, CANVAS_WIDTH * 0.020, CANVAS_HEIGHT * 0.220),
      new ToothPosition(17, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.295),
      new ToothPosition(18, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.375),
      new ToothPosition(51, CANVAS_WIDTH * 0.330, CANVAS_HEIGHT * 0.090),
      new ToothPosition(52, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.130),
      new ToothPosition(53, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.180),
      new ToothPosition(54, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.245),
      new ToothPosition(55, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.330)
    ]
  },
  bottom: {
    right: [
      new ToothPosition(41, CANVAS_WIDTH * 0.465, CANVAS_HEIGHT * 0.910),
      new ToothPosition(42, CANVAS_WIDTH * 0.580, CANVAS_HEIGHT * 0.895),
      new ToothPosition(43, CANVAS_WIDTH * 0.665, CANVAS_HEIGHT * 0.850),
      new ToothPosition(44, CANVAS_WIDTH * 0.730, CANVAS_HEIGHT * 0.790),
      new ToothPosition(45, CANVAS_WIDTH * 0.765, CANVAS_HEIGHT * 0.730),
      new ToothPosition(46, CANVAS_WIDTH * 0.785, CANVAS_HEIGHT * 0.665),
      new ToothPosition(47, CANVAS_WIDTH * 0.795, CANVAS_HEIGHT * 0.590),
      new ToothPosition(48, CANVAS_WIDTH * 0.800, CANVAS_HEIGHT * 0.505),
      new ToothPosition(71, CANVAS_WIDTH * 0.470, CANVAS_HEIGHT * 0.790),
      new ToothPosition(72, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.755),
      new ToothPosition(73, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.705),
      new ToothPosition(74, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.640),
      new ToothPosition(75, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.560)
    ],
    left: [
      new ToothPosition(31, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.910),
      new ToothPosition(32, CANVAS_WIDTH * 0.225, CANVAS_HEIGHT * 0.895),
      new ToothPosition(33, CANVAS_WIDTH * 0.125, CANVAS_HEIGHT * 0.850),
      new ToothPosition(34, CANVAS_WIDTH * 0.075, CANVAS_HEIGHT * 0.790),
      new ToothPosition(35, CANVAS_WIDTH * 0.045, CANVAS_HEIGHT * 0.730),
      new ToothPosition(36, CANVAS_WIDTH * 0.020, CANVAS_HEIGHT * 0.665),
      new ToothPosition(37, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.590),
      new ToothPosition(38, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.505),
      new ToothPosition(81, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.790),
      new ToothPosition(82, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.755),
      new ToothPosition(83, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.705),
      new ToothPosition(84, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.640),
      new ToothPosition(85, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.560)
    ]
  }
}

const ALL_TEETH = [
  new ToothPosition(21, CANVAS_WIDTH * 0.465, CANVAS_HEIGHT * 0.000),
  new ToothPosition(22, CANVAS_WIDTH * 0.580, CANVAS_HEIGHT * 0.015),
  new ToothPosition(23, CANVAS_WIDTH * 0.665, CANVAS_HEIGHT * 0.050),
  new ToothPosition(24, CANVAS_WIDTH * 0.730, CANVAS_HEIGHT * 0.100),
  new ToothPosition(25, CANVAS_WIDTH * 0.765, CANVAS_HEIGHT * 0.155),
  new ToothPosition(26, CANVAS_WIDTH * 0.785, CANVAS_HEIGHT * 0.220),
  new ToothPosition(27, CANVAS_WIDTH * 0.795, CANVAS_HEIGHT * 0.295),
  new ToothPosition(28, CANVAS_WIDTH * 0.800, CANVAS_HEIGHT * 0.375),
  new ToothPosition(61, CANVAS_WIDTH * 0.460, CANVAS_HEIGHT * 0.090),
  new ToothPosition(62, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.130),
  new ToothPosition(63, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.180),
  new ToothPosition(64, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.245),
  new ToothPosition(65, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.330),
  new ToothPosition(11, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.000),
  new ToothPosition(12, CANVAS_WIDTH * 0.225, CANVAS_HEIGHT * 0.015),
  new ToothPosition(13, CANVAS_WIDTH * 0.125, CANVAS_HEIGHT * 0.050),
  new ToothPosition(14, CANVAS_WIDTH * 0.075, CANVAS_HEIGHT * 0.100),
  new ToothPosition(15, CANVAS_WIDTH * 0.045, CANVAS_HEIGHT * 0.155),
  new ToothPosition(16, CANVAS_WIDTH * 0.020, CANVAS_HEIGHT * 0.220),
  new ToothPosition(17, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.295),
  new ToothPosition(18, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.375),
  new ToothPosition(51, CANVAS_WIDTH * 0.330, CANVAS_HEIGHT * 0.090),
  new ToothPosition(52, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.130),
  new ToothPosition(53, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.180),
  new ToothPosition(54, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.245),
  new ToothPosition(55, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.330),
  new ToothPosition(41, CANVAS_WIDTH * 0.465, CANVAS_HEIGHT * 0.910),
  new ToothPosition(42, CANVAS_WIDTH * 0.580, CANVAS_HEIGHT * 0.895),
  new ToothPosition(43, CANVAS_WIDTH * 0.665, CANVAS_HEIGHT * 0.850),
  new ToothPosition(44, CANVAS_WIDTH * 0.730, CANVAS_HEIGHT * 0.790),
  new ToothPosition(45, CANVAS_WIDTH * 0.765, CANVAS_HEIGHT * 0.730),
  new ToothPosition(46, CANVAS_WIDTH * 0.785, CANVAS_HEIGHT * 0.665),
  new ToothPosition(47, CANVAS_WIDTH * 0.795, CANVAS_HEIGHT * 0.590),
  new ToothPosition(48, CANVAS_WIDTH * 0.800, CANVAS_HEIGHT * 0.505),
  new ToothPosition(71, CANVAS_WIDTH * 0.470, CANVAS_HEIGHT * 0.790),
  new ToothPosition(72, CANVAS_WIDTH * 0.560, CANVAS_HEIGHT * 0.755),
  new ToothPosition(73, CANVAS_WIDTH * 0.600, CANVAS_HEIGHT * 0.705),
  new ToothPosition(74, CANVAS_WIDTH * 0.620, CANVAS_HEIGHT * 0.640),
  new ToothPosition(75, CANVAS_WIDTH * 0.625, CANVAS_HEIGHT * 0.560),
  new ToothPosition(31, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.910),
  new ToothPosition(32, CANVAS_WIDTH * 0.225, CANVAS_HEIGHT * 0.895),
  new ToothPosition(33, CANVAS_WIDTH * 0.125, CANVAS_HEIGHT * 0.850),
  new ToothPosition(34, CANVAS_WIDTH * 0.075, CANVAS_HEIGHT * 0.790),
  new ToothPosition(35, CANVAS_WIDTH * 0.045, CANVAS_HEIGHT * 0.730),
  new ToothPosition(36, CANVAS_WIDTH * 0.020, CANVAS_HEIGHT * 0.665),
  new ToothPosition(37, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.590),
  new ToothPosition(38, CANVAS_WIDTH * 0.010, CANVAS_HEIGHT * 0.505),
  new ToothPosition(81, CANVAS_WIDTH * 0.340, CANVAS_HEIGHT * 0.790),
  new ToothPosition(82, CANVAS_WIDTH * 0.250, CANVAS_HEIGHT * 0.755),
  new ToothPosition(83, CANVAS_WIDTH * 0.220, CANVAS_HEIGHT * 0.705),
  new ToothPosition(84, CANVAS_WIDTH * 0.200, CANVAS_HEIGHT * 0.640),
  new ToothPosition(85, CANVAS_WIDTH * 0.190, CANVAS_HEIGHT * 0.560)
]

export const TEETH = {
  arrayPosition: undefined,
  convertToArray: (teeth) => {
    if (this.arrayPosition) {
      return this.arrayPosition
    }
    if (teeth) {
      return compareArrays(ALL_TEETH, teeth)
    } else {
      return ALL_TEETH
    }
  }
}

function compareArrays (arr1, arr2) {
  let result = []
  arr1.sort()
  arr2.sort()
  for (let i = 0; i < arr1.length; i++) {
    if (arr2.indexOf(arr1[i].id) > -1) {
      result.push(arr1[i])
    }
  }
  return result
}

export const CHILD_TEETH = {
  arrayPositions: undefined,
  convertToArray: () => {
    if (this.arrayPositions) {
      return this.arrayPositions
    }
    const newArray = []
    const vertical = ['top', 'bottom']
    const horizontal = ['right', 'left']
    for (const height of vertical) {
      for (const side of horizontal) {
        newArray.push(...test[height][side])
      }
    }
    this.arrayPositions = newArray
    return newArray
  }
}

export const SIX_YEARS = {
  arrayPositions: undefined,
  convertToArray: () => {
    if (this.arrayPositions) {
      return this.arrayPositions
    }
    const newArray = []
    const vertical = ['top', 'bottom']
    const horizontal = ['right', 'left']
    for (const height of vertical) {
      for (const side of horizontal) {
        newArray.push(...milkAndPermanentTeethPositions[height][side])
      }
    }
    this.arrayPositions = newArray
    return newArray
  }
}

export const PERMANENT_TEETH = {
  arrayPositions: undefined,
  convertToArray: () => {
    if (this.arrayPositions) {
      return this.arrayPositions
    }
    const newArray = []
    const vertical = ['top', 'bottom']
    const horizontal = ['right', 'left']
    for (const height of vertical) {
      for (const side of horizontal) {
        newArray.push(...permanentTeethPositions[height][side])
      }
    }
    this.arrayPositions = newArray
    return newArray
  }
}



// WEBPACK FOOTER //
// ./src/components/general/TeethView/TeethPositionConstants.js